import { IEmployeeBudget } from '@/common/integrations/menhir/employee/budgets/budgets.types';
import { getPercentageOfBudgetUsed } from '@/common/utils/budgets';

export function getBudgetUsagePercentage(employeeBudget: IEmployeeBudget) {
  const actualPercentage =
    100 - (getPercentageOfBudgetUsed(employeeBudget) ?? 0);
  return actualPercentage === 0 ? 0 : Math.max(actualPercentage, 2);
}
